export default[
    {
        show(row,extra){
            return(
               row.shbj==='1'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '合同已签订';
        }
    },{
        show(row,extra){
            return(
               row.shbj==='0'
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '合同未签订';
        }
    },{
        show(row,extra){
            return(
               row.shbj==='3'
            )
        },
        tag:'my-tag',
        type:'success',
        text(row){
            return '履约完成';
        }
    },{
        show(row,extra){
            return(
               row.shbj==='2'
            )
        },
        tag:'my-tag',
        type:'danger',
        text(row){
            return '交易取消';
        }
    }
]